var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'mg-container': !_vm.fullColumn,
        'mobile-no-margin': _vm.mobileNoMargin
    },style:(Object.assign({}, _vm.containerStyle,
        {'padding-top': _vm.noPadding ? '' : _vm.paddingTop,
        'margin-bottom': _vm.noMargin ? '' : _vm.marginBottom}))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }